import React, { createContext, useContext, PropsWithChildren } from "react";
import { makeFailure, makeSuccess } from "../../sg-core";
import { useFileUploadContext } from "../../sg-fileupload";
import { ISignatureOptions } from "../models/ISignatureOptions";
import { useHprContext } from "../../sg-hpr";

const Context = createContext<ISignatureOptions | undefined>(undefined);

export const useSignatureWidgetContext = () => useContext(Context);

interface SignatureWidgetContextProps {
    options: ISignatureOptions;
};

export const SignatureWidgetProvider: React.FC<PropsWithChildren<SignatureWidgetContextProps>> = ({ options, children }) => {

    const uploadContext = useFileUploadContext();
    const hprContext = useHprContext();

    const uploadSignature: ISignatureOptions["uploadSignature"] = async (data: any) => {
        if (uploadContext) {
            try {
                return makeSuccess((await uploadContext.uploadFile(data)).id);
            } catch (error) {
                return makeFailure(error as Error)
            }
        }
        return makeFailure(Error("Signature widget requires upload context"))
    };


    const renderSignatoryName: ISignatureOptions["renderSignatoryName"] = async ({ personId, name }) => {
        if (hprContext && personId) {
            return (
                <span> personId: {personId} </span>
            )
        }
        return (
            <span>{name}</span>
        )

    };

    return (
        <Context.Provider value={{ ...options, uploadSignature, renderSignatoryName }}>
            {children}
        </Context.Provider>
    );
};